import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { Router } from '@angular/router';

@Component({
  selector: 'cl-auth-callback',
  standalone: true,
  template: `<p>Authenticating...</p>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthCallbackComponent implements OnInit {
  private readonly oauth = inject(OAuthService);
  private readonly router = inject(Router);

  ngOnInit() {
    this.oauth.tryLoginCodeFlow().then(() => this.router.navigateByUrl('/'));
  }
}
